import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Index from './pages/Index';
import PaketPris from './pages/PaketPris';
import NotFound from './pages/NotFound';
import './index.css';

// Simple inline test component to avoid import resolution issues
const SimpleTestPage = () => {
  const [directImageError, setDirectImageError] = useState(false);
  const [proxyImageError, setProxyImageError] = useState(false);
  
  // Direct Supabase URL for testing - using an actual image from the bucket
  const directSupabaseUrl = "https://mwztymqscvifvnfhxnip.supabase.co/storage/v1/object/public/portfolio-media//1744890658396_Rectangle_1_copy_1.png";
  
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Simple Image Test</h1>
      <p className="mb-4">Testing with actual image from Supabase bucket</p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="border p-4 rounded">
          <h3 className="font-medium mb-2">Local Placeholder</h3>
          <img 
            src="/placeholder.svg" 
            alt="Standard image test" 
            className="w-full h-64 object-cover"
          />
          <p className="mt-2 text-sm text-gray-500">Local placeholder image</p>
        </div>
        
        <div className="border p-4 rounded">
          <h3 className="font-medium mb-2">Direct Supabase Image</h3>
          {directImageError ? (
            <div className="w-full h-64 flex items-center justify-center bg-gray-100">
              <p>Direct image failed to load - check console</p>
            </div>
          ) : (
            <img 
              src={directSupabaseUrl}
              alt="Direct Supabase image" 
              className="w-full h-64 object-cover"
              onError={(e) => {
                console.error('Direct Supabase image error');
                setDirectImageError(true);
                e.currentTarget.src = '/placeholder.svg';
              }}
            />
          )}
          <p className="mt-2 text-sm text-gray-500 break-all">{directSupabaseUrl}</p>
        </div>
      </div>
      
      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="border p-4 rounded">
          <h3 className="font-medium mb-2">Direct with Timestamp</h3>
          <img 
            src={`${directSupabaseUrl}?t=${Date.now()}`}
            alt="Direct with timestamp" 
            className="w-full h-64 object-cover"
            onError={(e) => {
              console.error('Direct with timestamp error');
              e.currentTarget.src = '/placeholder.svg';
            }}
          />
          <p className="mt-2 text-sm text-gray-500">With timestamp to prevent caching</p>
        </div>
        
        <div className="border p-4 rounded">
          <h3 className="font-medium mb-2">API Proxy (For Comparison)</h3>
          {proxyImageError ? (
            <div className="w-full h-64 flex items-center justify-center bg-gray-100">
              <p>Proxy image failed to load - check console</p>
            </div>
          ) : (
            <img 
              src={`/api/image-proxy?url=${encodeURIComponent(directSupabaseUrl)}`}
              alt="API proxy test" 
              className="w-full h-64 object-cover"
              onError={(e) => {
                console.error('API proxy image error');
                setProxyImageError(true);
                e.currentTarget.src = '/placeholder.svg';
              }}
            />
          )}
          <p className="mt-2 text-sm text-gray-500">Using our custom image proxy</p>
        </div>
      </div>
      
      <div className="mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded">
        <h3 className="text-lg font-semibold text-yellow-800">Testing Notes</h3>
        <p className="mt-2">
          We're using a specific image from your Supabase bucket. If it doesn't load directly, it's likely due to CORS restrictions.
        </p>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/paket-pris" element={<PaketPris />} />
        <Route path="/testimage" element={<SimpleTestPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
